/// <amd-dependency path='VSS/LoaderPlugins/Css!WorkItemArea' />

import * as React from "react";
import ColumnOptionHelper = require("TestManagement/Scripts/TFS.TestManagement.ColumnOptionHelper");
import { registerLWPComponent } from "VSS/LWP";
import { showColumnOptionsPanel, INotAFieldColumn } from "WorkItemTracking/Scripts/Queries/Components/ColumnOptions/ColumnOptionsPanel";
import { IColumnOptionsPanelDisplayColumn } from "WorkItemTracking/Scripts/OM/QueryInterfaces";
import { FieldDefinition } from "WorkItemTracking/Scripts/TFS.WorkItemTracking";
import { TestCaseCategoryUtils } from "TestManagement/Scripts/TFS.TestManagement.Utils";
import q = require("q");
import { delegate } from "VSS/Utils/Core";

export interface IColumnOptionsPanelProps {
    onSuccess(displayColumns: string[], displayColumnNames: string[], newColumnsAdded: boolean): void;
    existingColumnFields: string[];
    allColumnFields: INotAFieldColumn[];
}

// This is a proxy component to load the query selector dialog using LegacyComponent
class ColumnOptionsPanelProxy extends React.Component<IColumnOptionsPanelProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        showColumnOptionsPanel({
            displayColumns: this.props.existingColumnFields.map(
                dc =>
                    ({
                        fieldRefName: dc
                    } as IColumnOptionsPanelDisplayColumn)
            ),
            allowSort: false,
            getFieldWidth: this._getColumnWidth,
            getAvailableNotAFieldColumns: delegate(this, this._getAvailableNotAFieldColumnsAsFieldDefinitions), //need to delegate to get the props
            getAvailableFields: this._getAvailableColumnsAsFieldDefinitions,
            onOkClick: (result: any, dataChanged?: boolean) => {
                if (dataChanged) {
                    if (result && result.display && result.display.length > 0) {
                        this.props.onSuccess(result.display.map(columns => columns.name), result.display.map(columns => columns.text), result.added && result.added.length > 0);
                    } else {
                        return [];
                    }
                }
            }
        });
    }

    private _getAvailableColumnsAsFieldDefinitions = (): Promise<FieldDefinition[]> => {
        const deferred = q.defer<FieldDefinition[]>();

        // get the custom WIT fields only
        TestCaseCategoryUtils.getAllTestCaseCategoryWorkItemFields((witFields: FieldDefinition[]) => {
            let fields = witFields.filter(
                f => !ColumnOptionHelper.ColumnOptions.isFixedField(f) && !ColumnOptionHelper.ColumnOptions.isHiddenField(f) && f.isCustomField()
            );
            deferred.resolve(fields);
        }, deferred.reject);

        return deferred.promise;
    };

    private _getAvailableNotAFieldColumnsAsFieldDefinitions(): INotAFieldColumn[] {
        // returns all possible fields
        return this.props.allColumnFields;
    }

    private _getColumnWidth = (fieldRefName: string): number => {
        return 80;
    };
}

registerLWPComponent("column-options-panel-proxy", ColumnOptionsPanelProxy);
